<template>
  <!-- Tabela com os itens que deverão ser avaliados -->
  <v-data-table
    :headers="headers"
    :items="value"
    :items-per-page="-1"
    class="mt-4"
    hide-default-footer
    hide-default-header
  >
    <!-- Nota -->
    <template v-slot:[`item.rating`]="{ item }">
      <app-rating
        :value="item.nota"
        :disabled="disabled"
        :tamanho="value.length > 1 ? 28 : 36"
      />
    </template>
  </v-data-table>
</template>

<script>
import AppRating from '@/components/core/AppRating';

export default {
  name: 'AvaliacaoFormGestorList',

  components: { AppRating },

  props: {
    value: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    headers() {
      return [
        { text: '', value: 'responsabilidade.tituloAtual', sortable: false },
        {
          text: '',
          value: 'responsabilidade.unidade.sigla',
          align: 'center',
          width: '15%',
          sortable: false,
        },
        {
          text: '',
          sortable: false,
          value: 'rating',
          align: 'end',
          width: '15%',
        },
      ];
    },
  },
};
</script>
